module.exports = __webpack_public_path__ + "img/cg-glass-coder-bg.b353aa90.jpg";